import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  SpacerV,
  FeatureCard,
  Stats,
} from "../components/Hero";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WindowIcon from "@mui/icons-material/Window";
import TabIcon from "@mui/icons-material/Tab";
import DvrIcon from "@mui/icons-material/Dvr";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import Lottie from "react-lottie";

export default function Software() {
  useEffect(() => {}, []);

  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <Hero
          background={
            "linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%)"
          }
          title="UI/UX Design"
          subtitle={
            <div>
              <p>
                Our UI/UX design expertise ensures visually stunning, intuitive,
                and user-centric experiences that drive engagement and
                conversions. Here’s why we’re the right choice for your project:
              </p>
              {!state.auth.isMobile ? (
                <ul>
                  <li>
                    <strong>User-Centered Design</strong>: We create seamless,
                    user-friendly interfaces that enhance customer satisfaction
                    and usability.
                  </li>
                  <li>
                    <strong>Modern Aesthetics & Functionality</strong>: Our
                    designs combine the latest trends with functional excellence
                    to ensure visually appealing and efficient digital
                    experiences.
                  </li>
                  <li>
                    <strong>Prototyping & Usability Testing</strong>: We
                    validate our designs through wireframing, prototyping, and
                    real user testing to ensure a smooth and intuitive
                    experience.
                  </li>
                </ul>
              ) : (
                ""
              )}
              <p>
                By hiring us, you gain a partner dedicated to crafting engaging,
                high-quality UI/UX solutions that elevate your brand and enhance
                user satisfaction.
              </p>
            </div>
          }
        />

        <ContentSideBySideInv
          title="UI/UX Benefits"
          subtitle={
            <div style={{ marginLeft: "15px" }}>
              {/* Better Decision-Making Section */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "orange",
                    marginRight: "15px",
                  }}
                />
                <div>
                  <div
                    style={{
                      color: "black",
                      fontWeight: 600,
                      fontSize: "18px",
                    }}
                  >
                    Enhanced User Satisfaction
                  </div>
                  <div
                    style={{
                      color: "#555",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
                    Effective UI/UX design provides a seamless and enjoyable experience, leading to higher user satisfaction and loyalty.
                  </div>
                </div>
              </div>

              {/* Accuracy Section */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "blue",
                    marginRight: "15px",
                  }}
                />
                <div>
                  <div
                    style={{
                      color: "black",
                      fontWeight: 600,
                      fontSize: "18px",
                    }}
                  >
                   Increased Engagement
                  </div>
                  <div
                    style={{
                      color: "#555",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
                    Well-designed interfaces attract and retain users, encouraging more interaction and higher conversion rates.
                  </div>
                </div>
              </div>

              {/* Process Optimization Section */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "teal",
                    marginRight: "15px",
                  }}
                />
                <div>
                  <div
                    style={{
                      color: "black",
                      fontWeight: 600,
                      fontSize: "18px",
                    }}
                  >
                    Reduced Development Costs
                  </div>
                  <div
                    style={{
                      color: "#555",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
                    Addressing usability issues early in the design process minimizes costly revisions and streamlines development.
                  </div>
                </div>
              </div>
            </div>
          }
          image={
            <img
              style={{ width: "100%", marginTop: "15px" }}
              src={require("../img/33.jpg")}
            />
          }
        />
        <SpacerV height={"100px"} />
        <ThreeSideBySide
          background={
            "linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%)"
          }
          spacing={5}
          subtitle1={
            <FeatureCard
              minHeight={"45vh"}
              title={"Research"}
              text={`In the Research phase, our approach is driven by data that
                echoes the user’s voice while aligning perfectly with your
                business objectives. This helps you to set the design patterns
                intuitively and clearly.`}
              icon={
                <TravelExploreIcon
                  style={{
                    fontSize: "50px",
                    color: "white",
                    marginRight: "15px",
                  }}
                />
              }
              gradient={
                "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
              }
            />
          }
          subtitle2={
            <FeatureCard
              minHeight={"45vh"}
              title={"Design"}
              text={`During the designing phase, our team of UX-UI experts dedicates
                itself to creating designs that are not only loved by users for
                their intuitiveness but are also scalable to meet growing
                demands and industry standards.`}
              icon={
                <DvrIcon
                  style={{
                    fontSize: "50px",
                    color: "white",
                    marginRight: "15px",
                  }}
                />
              }
              gradient={
                "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
              }
            />
          }
          subtitle3={
            <FeatureCard
              minHeight={"45vh"}
              title={"Build"}
              text={`In this phase, we transform designs into pixel-perfect,
                adaptable, and scalable products. Whether it’s a startup idea or
                an enterprise project, our technical prowess ensures that your
                vision is translated into reality.`}
              icon={
                <WindowIcon
                  style={{
                    fontSize: "50px",
                    color: "white",
                    marginRight: "15px",
                  }}
                />
              }
              gradient={
                "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
              }
            />
          }
        />
        <Stats />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
